// utils/dteAmounts.js

export const formatCLP = value =>
  Number(value ?? 0).toLocaleString('es-CL', {
    style: 'currency',
    currency: 'CLP'
  })
